import { defineComponent as _defineComponent } from 'vue'
import { __ } from '@@/bits/intl'
import OzBox, { OzBoxColors } from '@@/library/v4/components/OzBox.vue'
import OzIconButton, {
  OzIconButtonColorScheme,
  OzIconButtonSizePreset,
} from '@@/library/v4/components/OzIconButton.vue'
import OzRowToggle from '@@/library/v4/components/OzRowToggle.vue'
import OzScreenSizeAwareSideModal from '@@/library/v4/components/OzScreenSizeAwareSideModal.vue'
import { useDarkModeStore } from '@@/pinia/dark_mode'
import { useSurfaceContainerSizeStore } from '@@/pinia/surface_container_size'
import { useSurfaceShareLinksStore } from '@@/pinia/surface_share_links'
import { useSurfaceSharePanelStore } from '@@/pinia/surface_share_panel'
import SurfacePanelHeader from '@@/vuecomponents/SurfacePanelHeader.vue'
import { storeToRefs } from 'pinia'
import SurfaceSharePanelSubmissionRequestLinkSection from 'vuecomponents/SurfaceSharePanelSubmissionRequestLinkSection.vue'
import SurfaceSharePanelSubmissionRequestSettingsSection from 'vuecomponents/SurfaceSharePanelSubmissionRequestSettingsSection.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfaceSharePanelSubmissionRequestPanel',
  setup(__props) {

const { isContainerSmallerThanTabletPortrait, isContainerSmallerThanDesktop } = storeToRefs(
  useSurfaceContainerSizeStore(),
)
const { isDarkMode } = storeToRefs(useDarkModeStore())
const { activePanel } = storeToRefs(useSurfaceSharePanelStore())
const surfaceShareLinksStore = useSurfaceShareLinksStore()
const { isSubmissionRequestEnabled, isEnablingSubmissionRequest } = storeToRefs(surfaceShareLinksStore)
const { toggleSubmissionRequest } = surfaceShareLinksStore

return { __sfc: true,isContainerSmallerThanTabletPortrait, isContainerSmallerThanDesktop, isDarkMode, activePanel, surfaceShareLinksStore, isSubmissionRequestEnabled, isEnablingSubmissionRequest, toggleSubmissionRequest, __, OzBox, OzBoxColors, OzIconButton, OzIconButtonColorScheme, OzIconButtonSizePreset, OzRowToggle, OzScreenSizeAwareSideModal, SurfacePanelHeader, SurfaceSharePanelSubmissionRequestLinkSection, SurfaceSharePanelSubmissionRequestSettingsSection }
}

})